import { designService } from '@paragon/data-connections';
import { enqueueError } from '@paragon/notification-tools';
import { addSpinnerMessage, removeSpinnerMessage } from '@paragon/task-spinner';

import { productionComponentInstancesLoaded } from '../slices/productionComponentInstancesSlice';
import { AsyncThunkActionVoid } from './thunkActions';

export function updateAnalysisSetGuids(
  productionComponentInstanceGuidToUpdatedAnalysisSetGuid: {
    [productionComponentInstanceGuid: string]: string;
  },
  spinner = true,
): AsyncThunkActionVoid {
  return async function updateAnalysisSetGuidsThunkAction(dispatch) {
    const spinnerId = spinner ? dispatch(addSpinnerMessage('Updating production components...')) : null;

    try {
      const productionComponentInstances = await designService.productionComponentInstances.updateAnalysisSetGuids(
        productionComponentInstanceGuidToUpdatedAnalysisSetGuid,
      );

      dispatch(productionComponentInstancesLoaded(productionComponentInstances));
    } catch (exception) {
      console.error(exception);
      dispatch(enqueueError('Error updating production components'));
    } finally {
      if (spinnerId != null) dispatch(removeSpinnerMessage(spinnerId));
    }
  };
}
